// Copyright (c) 2018 Deere & Company

import {translate} from '../../../shared/services/translation-service';

export const getPipSearchColumns = () => ({
    listColumns: [
        {
            id: 'title',
            key: translate('PIP')
        },
        {
            id: 'pipStatus',
            key: translate('PIP_STATUS')
        },
        {
            id: 'pipType',
            key: translate('PIP_TYPE')
        },
        {
            id: 'expires',
            key: translate('EXPIRES')
        },
        {
            id: 'terminates',
            key: translate('TERMINATES')
        },
        {
            id: 'metric',
            key: translate('METRIC')
        },
        {
            id: 'dtacSolution',
            key: translate('DTAC_SOLUTION')
        },
        {
            id: 'daysRemaining',
            key: translate('DAYS_REMAINING')
        }
    ],
    listId: 'pipSearch'
});



// WEBPACK FOOTER //
// ./src/pip/pip-search/services/pip-search-excel-columns.js